import styled from "styled-components";

export const SchoolBlock = styled.div``;

export const SchoolContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 90px;
`;

export const HeadText = styled.p`
  line-height: 1.2;
  font-size: clamp(28px, 4vw, 44px);
  text-align: center;
  color: var(--color-primary);
  font-weight: 800;
  letter-spacing: -0.5px;
  max-width: 1200px;
  margin: 0 auto 30px;
`;
